var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'יש בעיה עם פרטי החשבונות.',"text":'אי אפשר לעדכן את התזרים כי חלק מפרטי החשבונות שאצלינו לא עובדים.',"notification-buttons":[
                      {
                        title:'לעדכון פרטים',
                        variant: 'primary',
                        action: _vm.goToCredentialsSettings,
                      } ],"icon-type":'danger'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dbc3562","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/notification/notification-types/UpdateCredentialsNotification.vue
// module id = null
// module chunks = 